// debug 时， 拷贝 mock.ts 数据，放在 template.ts
// 结束后，template.ts 文件需要置空
// export const debugTemplate = {} as any;

export const debugTemplate = {
    preview: 'https://xiuxiu-pro-pre.meitudata.com/designer/afb4dcbfd4e12c940d587dc5f25217a6.jpeg',
    name: '测试1副本',
    version: '20.0.0',
    templateConf: [
        {
            settingType: null,
            width: 3914,
            height: 2208,
            layers: [
                {
                    id: '0a7382e0-e365-40dc-be95-f29725d6ac28',
                    layerType: 'bg',
                    width: 3914,
                    height: 2208,
                    left: 0,
                    top: 0,
                    rotate: 0,
                    isAILayer: false,
                    opacity: 1,
                    lock: false,
                    children: [],
                    shine: false,
                    url: '',
                    cutoutMaskURL: '',
                    maskURL: '',
                    stretchOption: 2,
                    naturalWidth: 2500,
                    naturalHeight: 2500,
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    hidden: false,
                    maskType: 0,
                    parentId: '',
                    title: '',
                    materialIds: {},
                    backgroundColor: '#ffffffff',
                    backgroundGradient: null,
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    id: '21aa774a-5eeb-45b7-bf51-a038b6e6ff46',
                    layerType: 'img',
                    width: 635,
                    isAILayer: false,
                    height: 385,
                    left: 2809,
                    top: 1516,
                    rotate: 0,
                    opacity: 1,
                    lock: false,
                    shine: false,
                    url: 'https://material-center.meitudata.com/material/image/631b0c6eac85d194.jpg',
                    cutoutMaskURL: '',
                    maskURL: '',
                    stretchOption: 2,
                    naturalWidth: 2500,
                    naturalHeight: 2500,
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1.6535,
                    },
                    effect: {
                        effectAlpha: 1,
                        glow: [],
                        shadow: [{ type: 3, blur: 0.3, hidden: false, brightness: 10, y: 1, opacity: 1, distance: 27 }],
                        stroke: [],
                        screenshotUrl:
                            'https://xiuxiu-pro-pre.meitudata.com/designer/0fbc53eb698ae4029cd0bea79353ee2e.png',
                    },
                    hidden: false,
                    maskType: 0,
                    parentId: '',
                    title: '',
                    materialIds: {
                        'background-material': ['9001000124'],
                        'imageEffect-material': ['1703237426954176'],
                    },
                    children: [],
                    aiTextExtension: null,
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    id: '65474e32-2eab-49a6-9d9e-4bad6e9828c8',
                    layerType: 'text',
                    width: 708,
                    height: 166,
                    left: 267,
                    top: 327,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字',
                    lock: false,
                    shine: false,
                    color: '#ffe466ff',
                    fontSize: 118,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [],
                    textShadow: [{ color: '#000000ff', hidden: false, x: 9, y: 2, blur: 0.43389830508474575 }],
                    textStroke: [{ color: '#000000ff', hidden: false, direction: 0, width: 0.8677966101694915 }],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'] },
                    textBackground: [],
                    textGradient: null,
                    listStyle: '',
                    children: [],
                    textContents: [
                        {
                            text: '双击',
                            color: '#ffffffff',
                            fontSize: 118,
                            fontFamily: 'NotoSansSC-Black',
                            bold: false,
                            italic: false,
                            lineThrough: false,
                            underline: false,
                        },
                        {
                            text: '编辑文字',
                            color: '#ffe466ff',
                            fontSize: 118,
                            fontFamily: 'NotoSansSC-Black',
                            bold: false,
                            italic: false,
                            lineThrough: false,
                            underline: false,
                        },
                    ],
                    shapeExtension: null,
                    screenshotUrl: null,
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { modified: false },
                },
                {
                    id: '3bb6bb81-5bc2-4d9b-8877-8842551530ea',
                    layerType: 'text',
                    width: 708,
                    height: 166,
                    left: 267,
                    top: 507,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字',
                    lock: false,
                    shine: false,
                    color: '#ffe466ff',
                    fontSize: 118,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [],
                    textShadow: [{ color: '#000000ff', hidden: false, x: 9, y: 2, blur: 0.43389830508474575 }],
                    textStroke: [{ color: '#000000ff', hidden: false, direction: 0, width: 0.8677966101694915 }],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'] },
                    textBackground: [],
                    textGradient: null,
                    listStyle: '',
                    children: [],
                    textContents: [
                        {
                            text: '双击',
                            color: '#ffffffff',
                            fontSize: 118,
                            fontFamily: 'NotoSansSC-Black',
                            bold: false,
                            italic: false,
                            lineThrough: false,
                            underline: false,
                        },
                        {
                            text: '编辑文字',
                            color: '#ffe466ff',
                            fontSize: 118,
                            fontFamily: 'NotoSansSC-Black',
                            bold: false,
                            italic: false,
                            lineThrough: false,
                            underline: false,
                        },
                    ],
                    shapeExtension: null,
                    screenshotUrl: null,
                    texture: {
                        name: '金色',
                        url: 'https://xiuxiu-pro.meitudata.com/poster/dc23b2e547e4de70d9641687fd00168b.jpg',
                        stretch: 'cover',
                        scale: 1,
                    },
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { modified: false },
                },
                {
                    id: '405af4af-875f-478b-b22e-0a21cc6528b8',
                    layerType: 'text',
                    width: 708,
                    height: 166,
                    left: 267,
                    top: 766,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字',
                    lock: false,
                    shine: false,
                    color: '#000000ff',
                    fontSize: 118,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [],
                    textShadow: [],
                    textStroke: [],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'], 'text-mark': ['9028010029267'] },
                    textBackground: [],
                    textGradient: null,
                    listStyle: '',
                    children: [],
                    shapeExtension: null,
                    screenshotUrl: null,
                    textMark: { materialId: '9028010029267', enableSize: false, size: 50, color: '#ff83e8ff' },
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { modified: false },
                },
                {
                    id: 'bd0087c3-1d2a-4ef8-8d62-eb78cee40679',
                    layerType: 'text',
                    width: 708,
                    height: 166,
                    left: 1257,
                    top: 323,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字',
                    lock: false,
                    shine: false,
                    color: '#ffe466ff',
                    fontSize: 118,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [{ color: '#ffaaf2ff', hidden: false, width: 2.776949152542373 }],
                    textShadow: [{ color: '#000000ff', hidden: false, x: 9, y: 2, blur: 0.43389830508474575 }],
                    textStroke: [{ color: '#000000ff', hidden: false, direction: 0, width: 0.8677966101694915 }],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'] },
                    textBackground: [],
                    textGradient: null,
                    listStyle: '',
                    children: [],
                    shapeExtension: null,
                    screenshotUrl: null,
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { modified: false },
                },
                {
                    id: '5f0f244a-8ce2-465c-a5cd-ecef1073f214',
                    layerType: 'text',
                    width: 708,
                    height: 166,
                    left: 1257,
                    top: 560,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字',
                    lock: false,
                    shine: false,
                    color: '#ffffffff',
                    fontSize: 118,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [],
                    textShadow: [{ color: '#000000ff', hidden: false, x: 9, y: 2, blur: 4.338983050847458 }],
                    textStroke: [
                        { color: '#000000ff', hidden: false, direction: 0, width: 1.0847457627118644 },
                        { color: '#c6b6ffff', hidden: false, direction: 0, width: 1.5186440677966102 },
                        { color: '#fff6cfff', hidden: false, direction: 0, width: 1.5186440677966102 },
                    ],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'] },
                    textBackground: [],
                    textGradient: {
                        colors: [
                            { color: '#ffffffff', value: 0.3963414634146341 },
                            { color: '#ffa9e3ff', value: 1 },
                        ],
                        angle: 180,
                    },
                    listStyle: '',
                    children: [],
                    shapeExtension: null,
                    screenshotUrl: null,
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { modified: false },
                },
                {
                    id: 'e272781f-580e-4cf8-bb86-5f9dbd72f680',
                    layerType: 'text',
                    width: 1025,
                    height: 444,
                    left: 1112,
                    top: 750,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字',
                    lock: false,
                    shine: false,
                    color: '#ffe466ff',
                    fontSize: 134,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [{ color: '#ffaaf2ff', hidden: true, width: 2.751044776119403 }],
                    textShadow: [{ color: '#000000ff', hidden: false, x: 10, y: 2, blur: 0.382089552238806 }],
                    textStroke: [{ color: '#000000ff', hidden: false, direction: 0, width: 0.9552238805970148 }],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'], 'text-transform': [1699523891681574] },
                    textBackground: [],
                    textGradient: null,
                    listStyle: '',
                    children: [],
                    shapeExtension: {
                        curveTextType: 1,
                        bendAngle: -100,
                        spacing: 0,
                        positionOffset: 0,
                        firstMarginRatio: 0,
                        progress: 0,
                        reverse: false,
                        aspectRatio: 0,
                        relativeHeight: 0,
                    },
                    screenshotUrl: 'https://xiuxiu-pro-pre.meitudata.com/designer/fd65ae33ec1b48be8b5c4ce3c758d58a.png',
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { modified: false },
                },
                {
                    id: '586df996-56f9-4df6-89ff-4efea3668680',
                    layerType: 'table',
                    width: 1255,
                    height: 606,
                    left: 267,
                    top: 1295,
                    rotate: 0,
                    opacity: 1,
                    lock: false,
                    shine: true,
                    screenshotUrl: 'https://xiuxiu-pro-pre.meitudata.com/designer/b6f552d2a5d9dcfd2bc718513dfb7b8a.png',
                    allStyleId: '1',
                    cells: [
                        [
                            { vIndex: 0, hIndex: 0, colSpan: 6, rowSpan: 1, content: '课程表', styleIds: ['4'] },
                            null,
                            null,
                            null,
                            null,
                            null,
                        ],
                        [
                            { vIndex: 1, hIndex: 0, colSpan: 1, rowSpan: 1, content: '语文', styleIds: ['2'] },
                            { vIndex: 1, hIndex: 1, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 1, hIndex: 2, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 1, hIndex: 3, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 1, hIndex: 4, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 1, hIndex: 5, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                        ],
                        [
                            { vIndex: 2, hIndex: 0, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 2, hIndex: 1, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 2, hIndex: 2, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 2, hIndex: 3, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 2, hIndex: 4, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 2, hIndex: 5, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                        ],
                        [
                            { vIndex: 3, hIndex: 0, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 3, hIndex: 1, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 3, hIndex: 2, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 3, hIndex: 3, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 3, hIndex: 4, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 3, hIndex: 5, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                        ],
                        [
                            { vIndex: 4, hIndex: 0, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 4, hIndex: 1, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 4, hIndex: 2, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 4, hIndex: 3, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 4, hIndex: 4, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                            { vIndex: 4, hIndex: 5, colSpan: 1, rowSpan: 1, content: '', styleIds: ['2'] },
                        ],
                    ],
                    baseCells: {
                        horizontal: [
                            207.6171875, 208.64054361979169, 208.63301595052084, 208.6328125, 208.6328125,
                            208.84358723958334,
                        ],
                        vertical: [120, 120, 120, 121, 120],
                    },
                    styles: {
                        '1': {
                            fontSize: 53,
                            border: {
                                top: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                                right: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                                bottom: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                                left: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                            },
                        },
                        '2': {
                            border: {
                                top: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                                right: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                                bottom: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                                left: { width: 4, style: 'line-0', color: '#b4b8bfff' },
                            },
                        },
                        '4': { backgroundColor: '#fff6cfff' },
                    },
                    presetId: 'da05c556',
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['100100193'] },
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { lockRatio: false },
                },
                {
                    screenshotUrl: 'https://xiuxiu-pro-pre.meitudata.com/designer/621d80f968a176e6e4e40859393e1761.png',
                    type: 'bar-basic',
                    chartData: [
                        [null, '系列1', '系列2'],
                        ['项目1', 8, 8],
                        ['项目2', 12, 10],
                        ['项目3', 16, 10],
                    ],
                    colors: ['#387dfdff', '#0dcbbbff'],
                    grid: { show: true },
                    legend: { show: true, position: 'bottom', textStyle: { fontSize: 25, color: '#999999ff' } },
                    categoryAxisLabel: {
                        show: true,
                        textStyle: { fontSize: 25, textAlign: 'center', color: '#999999ff' },
                    },
                    valueAxisLabel: { show: true, textStyle: { fontSize: 25, textAlign: 'right', color: '#999999ff' } },
                    series: {
                        itemStyle: { borderRadius: 9 },
                        label: { show: false, textStyle: { fontSize: 25, color: '#999999ff' } },
                    },
                    id: '7a0a4724-3847-4405-b285-2617a80ce1df',
                    children: [],
                    layerType: 'chart',
                    width: 983,
                    height: 747,
                    left: 1668,
                    top: 1295,
                    rotate: 0,
                    opacity: 1,
                    lock: false,
                    shine: false,
                    hidden: false,
                    title: '',
                    materialIds: { 'font-family': ['100100193'] },
                    fitWidth: 0,
                    fitHeight: 0,
                    extraInfo: { lockRatio: false },
                },
                {
                    id: '9c48e875-1267-43da-927c-069b2db13135',
                    layerType: 'text',
                    width: 708,
                    height: 496,
                    left: 2223,
                    top: 327,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    flipH: false,
                    flipV: false,
                    text: '双击编辑文字\n没问题\n是的',
                    lock: false,
                    shine: false,
                    color: '#ffe466ff',
                    fontSize: 118,
                    fontFamily: 'NotoSansSC-Black',
                    lineSpacing: 199.99999999999994,
                    letterSpacing: 0,
                    bold: false,
                    italic: false,
                    lineThrough: false,
                    underline: false,
                    textAlign: 'center',
                    writingMode: 'horizontal-tb',
                    textGlow: [],
                    textShadow: [{ color: '#000000ff', hidden: false, x: 9, y: 2, blur: 0.43389830508474575 }],
                    textStroke: [{ color: '#000000ff', hidden: false, direction: 0, width: 0.8677966101694915 }],
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'font-family': ['1698739624163516'] },
                    textBackground: [{ color: '#fcca00ff', roundWeight: 83, hidden: false, editable: true }],
                    textGradient: null,
                    listStyle: '',
                    children: [],
                    textContents: [
                        {
                            text: '双击',
                            color: '#ffffffff',
                            fontSize: 118,
                            bold: false,
                            italic: false,
                            underline: false,
                            lineThrough: false,
                            fontFamily: 'NotoSansSC-Black',
                            textMark: null,
                        },
                        {
                            text: '编辑文字\n没问题\n是的',
                            color: '#ffe466ff',
                            fontSize: 118,
                            bold: false,
                            italic: false,
                            underline: false,
                            lineThrough: false,
                            fontFamily: 'NotoSansSC-Black',
                            textMark: null,
                        },
                    ],
                    shapeExtension: null,
                    screenshotUrl: null,
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    markupType: 'arrow',
                    label: {
                        position: 'center',
                        rotate: 0,
                        width: 279,
                        height: 95,
                        type: 'num',
                        text: '',
                        num: 50,
                        units: ['cm'],
                        color: '#ffffffff',
                        lineSpacing: -199.99999999999994,
                        letterSpacing: 0,
                        fontSize: 95,
                        fontFamily: 'AlibabaPuHuiTi-Medium',
                        bold: false,
                        italic: false,
                        lineThrough: false,
                        underline: false,
                        background: '#000000ff',
                        roundWeight: 95,
                    },
                    anchor: { points: [], arrowLeft: [53, -52], arrowRight: [53, -52] },
                    centerOffset: { x: 0, y: 57 },
                    hasLine: true,
                    fill: { color: '#000000ff', dasharray: '1,2', linecap: 'square', width: 8 },
                    startPoint: { url: '', type: '', offset: 2, width: 0, height: 0 },
                    endPoint: { url: '', type: '', offset: 2, width: 0, height: 0 },
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    screenshotUrl: 'https://xiuxiu-pro-pre.meitudata.com/designer/47cbc35c870da53669faa5b308912398.png',
                    id: '9fe0aedf-8de2-40e4-9104-5b22b0165af6',
                    layerType: 'markup',
                    left: 2238,
                    top: 953,
                    rotate: 0,
                    opacity: 1,
                    width: 660,
                    height: 114,
                    shine: false,
                    lock: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'func-list': ['markup'] },
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    brushType: 'curve',
                    url: 'https://xiuxiu-pro-pre.meitudata.com/designer/92863c0240e5377d60311162c138132e.svg',
                    fills: [{ color: '#ffffff66', dasharray: '', linecap: 'round', width: 34, offsetX: 0, offsetY: 0 }],
                    stroke: { color: '#000000ff', dasharray: '', linecap: 'round', width: 15, offsetX: 0, offsetY: 0 },
                    startPoint: { url: '', type: '', offset: 2, width: 0, height: 0 },
                    endPoint: { url: '', type: '', offset: 2, width: 0, height: 0 },
                    radius: 0,
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    stretchOption: 1,
                    naturalWidth: 377,
                    naturalHeight: 227,
                    screenshotUrl: 'https://xiuxiu-pro-pre.meitudata.com/designer/fe9c427346c2bb16316c9a72c36ba97d.png',
                    id: '5de419c5-9b34-4952-81e3-b504bc997118',
                    layerType: 'brush',
                    left: 2784,
                    top: 1061,
                    rotate: 0,
                    opacity: 1,
                    width: 445,
                    height: 295,
                    shine: false,
                    lock: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: {},
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    id: 'c641d056-f59c-4ef6-83fa-5bd8d3078d26',
                    layerType: 'img',
                    width: 635,
                    isAILayer: false,
                    height: 635,
                    left: 3036,
                    top: 214,
                    rotate: 0,
                    opacity: 1,
                    lock: false,
                    shine: true,
                    url: 'https://material-center.meitudata.com/material/image/631b0c6eac85d194.jpg',
                    cutoutMaskURL: '',
                    maskURL: 'https://material-center-pre.meitudata.com/material/font/663f4119502a66350.svg',
                    stretchOption: 2,
                    naturalWidth: 2500,
                    naturalHeight: 2500,
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1.002515748031496,
                    },
                    effect: {
                        effectAlpha: 1,
                        glow: [],
                        shadow: [{ color: '#535353b2', blur: 0.7, hidden: false, x: -0.032, y: -0.022, type: 1 }],
                        stroke: [{ color: '#ffffffff', width: 0.2, hidden: false, strokeType: 0 }],
                        screenshotUrl:
                            'https://xiuxiu-pro-pre.meitudata.com/designer/cfbd8bf57ded60cbdc854c586f376fe5.png',
                    },
                    hidden: false,
                    maskType: 0,
                    parentId: '',
                    title: '',
                    materialIds: {
                        'background-material': ['9001000124'],
                        'mask-material': ['1714985136072408'],
                        'imageEffect-material': ['1703237426954176'],
                    },
                    children: [],
                    aiTextExtension: null,
                    fitWidth: 0,
                    fitHeight: 0,
                    minimumMask: true,
                },
            ],
        },
        {
            settingType: null,
            width: 1242,
            height: 2208,
            layers: [
                {
                    id: '839b1896-8959-4d06-8833-a9bbd0e56de7',
                    layerType: 'bg',
                    width: 1242,
                    height: 2208,
                    left: 0,
                    top: 0,
                    rotate: 0,
                    isAILayer: false,
                    opacity: 1,
                    lock: false,
                    children: [],
                    shine: false,
                    url: '',
                    cutoutMaskURL: '',
                    maskURL: '',
                    stretchOption: 2,
                    naturalWidth: 0,
                    naturalHeight: 0,
                    imageTransform: {
                        flipH: false,
                        flipV: false,
                        heightRatio: 1,
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        widthRatio: 1,
                    },
                    hidden: false,
                    maskType: 0,
                    parentId: '',
                    title: '',
                    materialIds: {},
                    backgroundColor: '#FFFFFFFF',
                    backgroundGradient: null,
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    url: 'https://material-center-pre.meitudata.com/material/image/67cee92cd1ce83695.webp',
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    mediaType: 'image',
                    naturalWidth: 600,
                    naturalHeight: 600,
                    autoplay: true,
                    loop: true,
                    controls: true,
                    id: '4474d561-a160-408d-96f9-adea799eaa18',
                    layerType: 'media',
                    left: 93,
                    top: 40,
                    rotate: 0,
                    opacity: 1,
                    width: 621,
                    height: 621,
                    shine: false,
                    lock: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'media-material': ['10124454'] },
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    url: 'https://material-center-pre.meitudata.com/material/image/67cee940959e41854.webp',
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    mediaType: 'image',
                    naturalWidth: 600,
                    naturalHeight: 600,
                    autoplay: true,
                    loop: true,
                    controls: true,
                    id: '56e17001-12dc-4252-88c9-e016b4e7fee2',
                    layerType: 'media',
                    left: 460,
                    top: 748,
                    rotate: 0,
                    opacity: 1,
                    width: 621,
                    height: 621,
                    shine: false,
                    lock: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'media-material': ['10128276'] },
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    url: 'https://material-center-pre.meitudata.com/material/image/67cee923609ef1260.webp',
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    mediaType: 'image',
                    naturalWidth: 300,
                    naturalHeight: 300,
                    autoplay: true,
                    loop: true,
                    controls: true,
                    id: '160701e9-1145-4aaa-b61f-5d97b97ffabb',
                    layerType: 'media',
                    left: 0,
                    top: 1368,
                    rotate: 0,
                    opacity: 1,
                    width: 621,
                    height: 621,
                    shine: false,
                    lock: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'media-material': ['10128380'] },
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    id: '6d0d7c48-a3c1-4995-a9c9-d8976acd5105',
                    layerType: 'group',
                    width: 503,
                    height: 551,
                    left: 194,
                    top: 701,
                    isAILayer: false,
                    rotate: 0,
                    opacity: 1,
                    shine: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: {},
                    children: [
                        {
                            url: 'https://material-center-pre.meitudata.com/material/image/67cee971620585800.webp',
                            imageTransform: {
                                offsetX: 0,
                                offsetY: 0,
                                rotate: 0,
                                scale: 1,
                                flipH: false,
                                flipV: false,
                                widthRatio: 1,
                                heightRatio: 1,
                            },
                            mediaType: 'image',
                            naturalWidth: 600,
                            naturalHeight: 600,
                            autoplay: true,
                            loop: true,
                            controls: true,
                            id: '9cc76a4e-3e82-47d2-8411-b79c3cee10c0',
                            layerType: 'media',
                            left: 262,
                            top: 816,
                            rotate: 30,
                            opacity: 1,
                            width: 368,
                            height: 368,
                            shine: false,
                            lock: false,
                            hidden: false,
                            parentId: '6d0d7c48-a3c1-4995-a9c9-d8976acd5105__1',
                            title: '',
                            materialIds: { 'media-material': ['10126635'] },
                            children: [],
                            fitWidth: 0,
                            fitHeight: 0,
                        },
                        {
                            url: 'https://material-center-pre.meitudata.com/material/image/67f7cf924ca3a8799.webp',
                            imageTransform: {
                                offsetX: 0,
                                offsetY: 0,
                                rotate: 0,
                                scale: 1,
                                flipH: false,
                                flipV: false,
                                widthRatio: 1,
                                heightRatio: 1,
                            },
                            mediaType: 'image',
                            naturalWidth: 600,
                            naturalHeight: 600,
                            autoplay: true,
                            loop: true,
                            controls: true,
                            id: '2f93fa1b-a7e2-482b-b851-d28cd5a1e11c',
                            layerType: 'media',
                            left: 283,
                            top: 701,
                            rotate: 0,
                            opacity: 1,
                            width: 204,
                            height: 204,
                            shine: false,
                            lock: false,
                            hidden: false,
                            parentId: '6d0d7c48-a3c1-4995-a9c9-d8976acd5105__1',
                            title: '',
                            materialIds: { 'media-material': ['10129529'] },
                            children: [],
                            fitWidth: 0,
                            fitHeight: 0,
                        },
                    ],
                    lock: false,
                    fitWidth: 0,
                    fitHeight: 0,
                },
                {
                    url: 'https://material-center-pre.meitudata.com/material/image/67cee937e079b2579.webp',
                    imageTransform: {
                        offsetX: 0,
                        offsetY: 0,
                        rotate: 0,
                        scale: 1,
                        flipH: false,
                        flipV: false,
                        widthRatio: 1,
                        heightRatio: 1,
                    },
                    mediaType: 'image',
                    naturalWidth: 600,
                    naturalHeight: 600,
                    autoplay: true,
                    loop: true,
                    controls: true,
                    id: 'cb744bb8-b625-412b-bcfd-3dcd84fc92f5',
                    layerType: 'media',
                    left: 575,
                    top: 1525,
                    rotate: 0,
                    opacity: 1,
                    width: 621,
                    height: 621,
                    shine: false,
                    lock: false,
                    hidden: false,
                    parentId: '',
                    title: '',
                    materialIds: { 'media-material': ['10127758'] },
                    children: [],
                    fitWidth: 0,
                    fitHeight: 0,
                },
            ],
        },
    ],
    editMode: 1,
} as any;
